import styled from "styled-components";

export const VignetteLoadingSkeletonContainer = styled.div`
  max-height: 85vh;
  width: 100%;

  aspect-ratio: 16/9;

  @media (max-width: 768px) {
    min-height: 500px;
  }
`;
